module.exports = __webpack_public_path__ + "static/media/outlook_icon.1f8c48e8.svg";